import { trackLanguageDropdownOpen } from './analytics/trackLanguageDropdownOpen';
import updateLangLink from './utils/updateLangLink.js';
/**
 * A custom element for enhancing the language button to open a dialog
 * with language selection options from the mobile menu
 *
 * @module iabbb-language-selector
 */

class DesktopLanguageSelector extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (!this.button) {
      return;
    }

    this.button.addEventListener('click', () => this.openDialog());

    const dialog = document.querySelector('.language-dialog');
    if (dialog) {
      this.setupCloseHandlers(dialog);
      this.setupLanguageLinks(dialog);
    } else {
      // Wait for dialog to appear in DOM
      const observer = new MutationObserver(() => {
        const dialog = document.querySelector('.language-dialog');
        if (dialog) {
          observer.disconnect();
          this.setupCloseHandlers(dialog);
          this.setupLanguageLinks(dialog);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  openDialog = () => {
    const languageDialog = document.querySelector('.language-dialog');

    //Analytic: Desktop - header_language_dropdown_open
    if (languageDialog) {
      trackLanguageDropdownOpen();
    }

    languageDialog.style.display = 'block';

    // Position and show dialog
    this.positionDialog(languageDialog);
    languageDialog.showModal();
  };

  closeDialog = () => {
    const languageDialog = document.querySelector('.language-dialog');
    languageDialog.style.display = 'none';
    this.button.focus();
  };

  setupLanguageLinks = (dialog) => {
    const languageLinks = dialog.querySelectorAll('.gtranslate_wrapper a');

    for (const link of languageLinks) {
      updateLangLink(link, this.closeDialog);
    }
  };

  positionDialog = (dialog) => {
    const buttonRect = this.button.getBoundingClientRect();

    // Position dialog below the button
    dialog.style.position = 'fixed';
    dialog.style.left = `${buttonRect.left}px`;
    dialog.style.top = `${buttonRect.bottom + 8}px`;
    dialog.style.margin = '0';
  };

  setupCloseHandlers = (dialog) => {
    // Close when clicking outside (backdrop click)
    dialog.addEventListener('click', (e) => {
      const dialogDimensions = dialog.getBoundingClientRect();
      if (
        e.clientX < dialogDimensions.left ||
        e.clientX > dialogDimensions.right ||
        e.clientY < dialogDimensions.top ||
        e.clientY > dialogDimensions.bottom
      ) {
        dialog.close();
      }
    });

    // Close when dialog is closed
    dialog.addEventListener('close', () => {
      this.closeDialog();
    });
  };
}

customElements.define('iabbb-language-selector', DesktopLanguageSelector);
